import { EnvironmentId } from '@/react/portainer/environments/types';
import axios from '@/portainer/services/axios/axios';

interface CreateStackCommandRequest {
  StackOperation: string;
  RemoveVolumes: boolean;
}

export async function removeStack(
  endpointId: EnvironmentId,
  stackId: number,
  removeVolumes: boolean = false
) {
  const payload: CreateStackCommandRequest = {
    StackOperation: 'remove',
    RemoveVolumes: removeVolumes,
  };
  await axios.post<void>(urlBuilder(endpointId, stackId), payload);
}

export function urlBuilder(endpointId: EnvironmentId, stackId: number) {
  return `/endpoints/${endpointId}/edge/async/commands/stack/${stackId}`;
}
